import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import "@config/firebase";

const getSentryEnvironment = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost") return "dev";
    if (host.includes("beta.")) return "beta";
  }
  return "prod";
};

const sentryEnvironment = getSentryEnvironment();

Sentry.init({
  dsn: "https://89d504b1676c4c19638a481ef6620ca6@o4510868603142144.ingest.us.sentry.io/4510868621033472",
  enableLogs: true,
  enabled: sentryEnvironment !== "dev",
  environment: sentryEnvironment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  sendDefaultPii: true,
  // Tracing — lower in production to reduce volume
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/.*\.latteconnect\.app/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
